"use client";

import React from "react";
import usePackage from "./usePackage";

/** Same typography scale used in LearnMode */
const t = {
  caption:
    "text-[14px] leading-[21px] font-[400] [font-family:'Raveo_Display',sans-serif]",
  h2:
    "md:text-[40px] text-[28px] leading-[35px] md:leading-[50px] font-[600] [font-family:'Raveo_Display',sans-serif] text-[#022850] text-center ",
  cardTitle:
    "text-[40px] leading-[50px] font-[600] [font-family:'Raveo_Display',sans-serif]",
  perk:
    "text-[14px] leading-[21px] font-[400] [font-family:'Raveo_Display',sans-serif]",
};

/** faint mesh overlay svg */
const Mesh = () => (
              <svg xmlns="http://www.w3.org/2000/svg" width="199" height="120" viewBox="0 0 199 120" fill="none">
                <path d="M20.7 1H1V20.6667M20.7 1V20.6667M20.7 1H40.4M20.7 20.6667H1M20.7 20.6667H40.4M20.7 20.6667V40.3333M1 20.6667V40.3333M40.4 1V20.6667M40.4 1H60.1M40.4 20.6667H60.1M40.4 20.6667V40.3333M60.1 1V20.6667M60.1 1H79.8M60.1 20.6667H79.8M60.1 20.6667V40.3333M79.8 1V20.6667M79.8 1H99.5M79.8 20.6667H99.5M79.8 20.6667V40.3333M99.5 1V20.6667M99.5 1H119.2M99.5 20.6667H119.2M99.5 20.6667V40.3333M119.2 1V20.6667M119.2 1H138.9M119.2 20.6667H138.9M119.2 20.6667V40.3333M138.9 1V20.6667M138.9 1H158.6M138.9 20.6667H158.6M138.9 20.6667V40.3333M158.6 1V20.6667M158.6 1H178.3M158.6 20.6667H178.3M158.6 20.6667V40.3333M178.3 1V20.6667M178.3 1H198V20.6667M178.3 20.6667H198M178.3 20.6667V40.3333M198 20.6667V40.3333M20.7 40.3333H1M20.7 40.3333H40.4M20.7 40.3333V60M1 40.3333V60M40.4 40.3333H60.1M40.4 40.3333V60M60.1 40.3333H79.8M60.1 40.3333V60M79.8 40.3333H99.5M79.8 40.3333V60M99.5 40.3333H119.2M99.5 40.3333V60M119.2 40.3333H138.9M119.2 40.3333V60M138.9 40.3333H158.6M138.9 40.3333V60M158.6 40.3333H178.3M158.6 40.3333V60M178.3 40.3333H198M178.3 40.3333V60M198 40.3333V60M20.7 60H1M20.7 60H40.4M20.7 60V79.6667M1 60V79.6667M40.4 60H60.1M40.4 60V79.6667M60.1 60H79.8M60.1 60V79.6667M79.8 60H99.5M79.8 60V79.6667M99.5 60H119.2M99.5 60V79.6667M119.2 60H138.9M119.2 60V79.6667M138.9 60H158.6M138.9 60V79.6667M158.6 60H178.3M158.6 60V79.6667M178.3 60H198M178.3 60V79.6667M198 60V79.6667M20.7 79.6667H1M20.7 79.6667H40.4M20.7 79.6667V99.3333M1 79.6667V99.3333M40.4 79.6667H60.1M40.4 79.6667V99.3333M60.1 79.6667H79.8M60.1 79.6667V99.3333M79.8 79.6667H99.5M79.8 79.6667V99.3333M99.5 79.6667H119.2M99.5 79.6667V99.3333M119.2 79.6667H138.9M119.2 79.6667V99.3333M138.9 79.6667H158.6M138.9 79.6667V99.3333M158.6 79.6667H178.3M158.6 79.6667V99.3333M178.3 79.6667H198M178.3 79.6667V99.3333M198 79.6667V99.3333M20.7 99.3333H1M20.7 99.3333H40.4M20.7 99.3333V119M1 99.3333V119H20.7M40.4 99.3333H60.1M40.4 99.3333V119M60.1 99.3333H79.8M60.1 99.3333V119M79.8 99.3333H99.5M79.8 99.3333V119M99.5 99.3333H119.2M99.5 99.3333V119M119.2 99.3333H138.9M119.2 99.3333V119M138.9 99.3333H158.6M138.9 99.3333V119M158.6 99.3333H178.3M158.6 99.3333V119M178.3 99.3333H198M178.3 99.3333V119M198 99.3333V119H178.3M20.7 119H40.4M40.4 119H60.1M60.1 119H79.8M79.8 119H99.5M99.5 119H119.2M119.2 119H138.9M138.9 119H158.6M158.6 119H178.3" stroke="url(#paint0_radial_446_1864)"/>
                <defs>
                    <radialGradient id="paint0_radial_446_1864" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(134 51.5) rotate(-60.7621) scale(91.1071 125.063)">
                    <stop stop-color="#BDBBC1" stop-opacity="0.2"/>
                    <stop offset="1" stop-color="#BDBBC1" stop-opacity="0"/>
                    </radialGradient>
                </defs>
              </svg>
);

export default function Package() {
  const { UI, plans } = usePackage();

  return (
    <section className="w-full">
      <div className="mx-auto max-w-[1600px] px-7 md:px-[120px] py-16 md:py-24">
        {/* Section header */}
        <div className="mx-auto max-w-[1300px] items-center justify-center flex flex-col">
          <div
            className={`inline-flex items-center gap-[6px] rounded-[36px] border px-3 py-1 ${t.caption}`}
            style={{
              background: UI.captionBg,
              borderColor: UI.captionBorder,
              color: UI.captionText,
            }}
          >
             Learning Pace
          </div>
          <h2 className={`mt-6 md:mt-4 ${t.h2} md:whitespace-nowrap`}>
            Customized <br className="block md:hidden" />
            Delivery <span className="hidden md:inline"> - </span>Your Way
          </h2>
        </div>

        {/* Two plan cards */}
        <div className="mx-auto mt-8 md:mt-12 grid max-w-[1300px] grid-cols-1 gap-6 md:grid-cols-2">
          {/* Left: 1-to-1 */}
          <article
            className="relative rounded-[24px] p-6 md:p-8"
            style={{ background: plans[0].bg }}
          >
            <div className="absolute right-0 top-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="198" height="119" viewBox="0 0 198 119" fill="none">
                <path d="M20.7 0H1V19.6667M20.7 0V19.6667M20.7 0H40.4M20.7 19.6667H1M20.7 19.6667H40.4M20.7 19.6667V39.3333M1 19.6667V39.3333M40.4 0V19.6667M40.4 0H60.1M40.4 19.6667H60.1M40.4 19.6667V39.3333M60.1 0V19.6667M60.1 0H79.8M60.1 19.6667H79.8M60.1 19.6667V39.3333M79.8 0V19.6667M79.8 0H99.5M79.8 19.6667H99.5M79.8 19.6667V39.3333M99.5 0V19.6667M99.5 0H119.2M99.5 19.6667H119.2M99.5 19.6667V39.3333M119.2 0V19.6667M119.2 0H138.9M119.2 19.6667H138.9M119.2 19.6667V39.3333M138.9 0V19.6667M138.9 0H158.6M138.9 19.6667H158.6M138.9 19.6667V39.3333M158.6 0V19.6667M158.6 0H178.3M158.6 19.6667H178.3M158.6 19.6667V39.3333M178.3 0V19.6667M178.3 0H198V19.6667M178.3 19.6667H198M178.3 19.6667V39.3333M198 19.6667V39.3333M20.7 39.3333H1M20.7 39.3333H40.4M20.7 39.3333V59M1 39.3333V59M40.4 39.3333H60.1M40.4 39.3333V59M60.1 39.3333H79.8M60.1 39.3333V59M79.8 39.3333H99.5M79.8 39.3333V59M99.5 39.3333H119.2M99.5 39.3333V59M119.2 39.3333H138.9M119.2 39.3333V59M138.9 39.3333H158.6M138.9 39.3333V59M158.6 39.3333H178.3M158.6 39.3333V59M178.3 39.3333H198M178.3 39.3333V59M198 39.3333V59M20.7 59H1M20.7 59H40.4M20.7 59V78.6667M1 59V78.6667M40.4 59H60.1M40.4 59V78.6667M60.1 59H79.8M60.1 59V78.6667M79.8 59H99.5M79.8 59V78.6667M99.5 59H119.2M99.5 59V78.6667M119.2 59H138.9M119.2 59V78.6667M138.9 59H158.6M138.9 59V78.6667M158.6 59H178.3M158.6 59V78.6667M178.3 59H198M178.3 59V78.6667M198 59V78.6667M20.7 78.6667H1M20.7 78.6667H40.4M20.7 78.6667V98.3333M1 78.6667V98.3333M40.4 78.6667H60.1M40.4 78.6667V98.3333M60.1 78.6667H79.8M60.1 78.6667V98.3333M79.8 78.6667H99.5M79.8 78.6667V98.3333M99.5 78.6667H119.2M99.5 78.6667V98.3333M119.2 78.6667H138.9M119.2 78.6667V98.3333M138.9 78.6667H158.6M138.9 78.6667V98.3333M158.6 78.6667H178.3M158.6 78.6667V98.3333M178.3 78.6667H198M178.3 78.6667V98.3333M198 78.6667V98.3333M20.7 98.3333H1M20.7 98.3333H40.4M20.7 98.3333V118M1 98.3333V118H20.7M40.4 98.3333H60.1M40.4 98.3333V118M60.1 98.3333H79.8M60.1 98.3333V118M79.8 98.3333H99.5M79.8 98.3333V118M99.5 98.3333H119.2M99.5 98.3333V118M119.2 98.3333H138.9M119.2 98.3333V118M138.9 98.3333H158.6M138.9 98.3333V118M158.6 98.3333H178.3M158.6 98.3333V118M178.3 98.3333H198M178.3 98.3333V118M198 98.3333V118H178.3M20.7 118H40.4M40.4 118H60.1M60.1 118H79.8M79.8 118H99.5M99.5 118H119.2M119.2 118H138.9M138.9 118H158.6M158.6 118H178.3" stroke="url(#paint0_radial_443_1730)"/>
                <defs>
                    <radialGradient id="paint0_radial_443_1730" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(134 50.5) rotate(-60.7621) scale(91.1071 125.063)">
                    <stop stop-color="#F0EFF1" stop-opacity="0.2"/>
                    <stop offset="1" stop-color="#F0EFF1" stop-opacity="0"/>
                    </radialGradient>
                </defs>
              </svg>
            </div>
            <h3
              className={`${t.cardTitle} ${
                plans[0].lightText ? "text-white" : "text-[#242325]"
              }  whitespace-pre-line`}
            >
              {plans[0].title}
            </h3>

            <div className="mt-5 h-px w-full bg-white/50" />

            <ul className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">
              {plans[0].perks.map((p) => (
                <li key={p} className="flex items-start gap-3 ">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <path d="M7.41667 14.0833C8.2923 14.0844 9.15952 13.9125 9.9685 13.5774C10.7775 13.2423 11.5123 12.7506 12.1307 12.1307C12.7506 11.5123 13.2423 10.7775 13.5774 9.9685C13.9125 9.15952 14.0844 8.2923 14.0833 7.41667C14.0844 6.54103 13.9125 5.67381 13.5774 4.86483C13.2423 4.05585 12.7506 3.32106 12.1307 2.70267C11.5123 2.08272 10.7775 1.59108 9.9685 1.25598C9.15952 0.920875 8.2923 0.748925 7.41667 0.750005C6.54103 0.748925 5.67381 0.920875 4.86483 1.25598C4.05585 1.59108 3.32106 2.08272 2.70267 2.70267C2.08272 3.32106 1.59108 4.05585 1.25598 4.86483C0.920875 5.67381 0.748925 6.54103 0.750005 7.41667C0.748925 8.2923 0.920875 9.15952 1.25598 9.9685C1.59108 10.7775 2.08272 11.5123 2.70267 12.1307C3.32106 12.7506 4.05585 13.2423 4.86483 13.5774C5.67381 13.9125 6.54103 14.0844 7.41667 14.0833Z" stroke="#DBF5E9" stroke-width="1.5" stroke-linejoin="round"/>
                    <path d="M4.75 7.41699L6.75 9.41699L10.75 5.41699" stroke="#DBF5E9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span className={`${t.perk} text-[#F0EFF1]`}>{p}</span>
                </li>
              ))}
            </ul>

            <button onClick={() => (window.location.href = "/contact_us")}
              className="mt-6 w-full rounded-[12px] px-5 py-4 font-[600] text-[#38400D]"
              style={{
                background: "#FFFFFF",
                fontFamily: "Raveo Display, sans-serif",
              }}
            >
              Start Fast Track Classes
            </button>
          </article>

          {/* Right: Super 6 */}
          <article className="relative rounded-[24px] border border-[#E7E6EA] bg-white p-6 md:p-8 shadow-[0_10px_30px_rgba(0,0,0,0.06)]">
            {/* mesh + badge */}
            <div className="absolute right-0 top-0">
              <Mesh />
            </div>
            {plans[1].recommended && (
              <div
                className="absolute md:right-6 md:top-6 right-2 top-2 rounded-full px-3 py-1 md:text-[12px] text-[10px] font-[600]"
                style={{
                  background: "#ffffff",
                  color: "#4A3CF3",
                  border: "0.8px solid #4A3CF3",
                  fontFamily: "Raveo Display, sans-serif",
                }}
              >
                Recommended
              </div>
            )}

            <h3
              className={`${t.cardTitle}  whitespace-pre-line`}
              style={{ color:"#022850" }}
            >
              {plans[1].title}
            </h3>

            <div className="mt-5 h-px w-full bg-[#E9E8ED]" />

            <ul className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">
              {plans[1].perks.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <path d="M7.41667 14.0833C8.2923 14.0844 9.15952 13.9125 9.9685 13.5774C10.7775 13.2423 11.5123 12.7506 12.1307 12.1307C12.7506 11.5123 13.2423 10.7775 13.5774 9.9685C13.9125 9.15952 14.0844 8.2923 14.0833 7.41667C14.0844 6.54103 13.9125 5.67381 13.5774 4.86483C13.2423 4.05585 12.7506 3.32106 12.1307 2.70267C11.5123 2.08272 10.7775 1.59108 9.9685 1.25598C9.15952 0.920875 8.2923 0.748925 7.41667 0.750005C6.54103 0.748925 5.67381 0.920875 4.86483 1.25598C4.05585 1.59108 3.32106 2.08272 2.70267 2.70267C2.08272 3.32106 1.59108 4.05585 1.25598 4.86483C0.920875 5.67381 0.748925 6.54103 0.750005 7.41667C0.748925 8.2923 0.920875 9.15952 1.25598 9.9685C1.59108 10.7775 2.08272 11.5123 2.70267 12.1307C3.32106 12.7506 4.05585 13.2423 4.86483 13.5774C5.67381 13.9125 6.54103 14.0844 7.41667 14.0833Z" stroke="#4A3CF3" stroke-width="1.5" stroke-linejoin="round"/>
                    <path d="M4.75 7.41699L6.75 9.41699L10.75 5.41699" stroke="#4A3CF3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span className={`${t.perk} text-[#38400D]`}>{p}</span>
                </li>
              ))}
            </ul>

            <button onClick={() => (window.location.href = "/contact_us")}
              className="mt-6 w-full rounded-[12px] px-5 py-4 font-[600] text-[#38400D] "
              style={{
                background: UI.primary,
                fontFamily: "Raveo Display, sans-serif",
              }}
            >
              Join Super-Intensive Now
            </button>

            {/* subtle card outline to match mock curvature */}
            <div className="pointer-events-none absolute inset-0 rounded-[24px] ring-1 ring-black/5" />
          </article>
        </div>
      </div>
    </section>
  );
}
